// extracted by mini-css-extract-plugin
export default {"cvParsingConfigPage":"cv_parsing_conf_page___cvParsingConfigPage___ca014a9c","cvParsingConfigActions":"cv_parsing_conf_page___cvParsingConfigActions___dc8c1b15"};